import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import PageMeta from "../common/PageMeta";
import PageBreadcrumb from "../common/PageBreadCrumb";
import ComponentCard from "../common/ComponentCard";
import Pagination from "../common/Pagination";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "../ui/table";

import {
  TrashBinIcon,
  PencilIcon,
  CheckLineIcon,
  ChevronDownIcon,
  WhatsAppIcon
} from "../../icons";
import { Link } from "react-router";
import Badge from "../ui/badge/Badge";
import { getAllUserSubscription, resetGetAllUserSubscription, getUserSubscriptionByPlanId, resetGetUserSubscriptionByPlanId, getAllSubscriptions, deleteUserSubscriptionById, emptyRedux } from "../../actions/subscriptionAction";
import { sendWhatsAppPaymentLink, resetSendWhatsAppPaymentLink } from "../../actions/paymentAction";
import { checkAuth, emptyReduxUser } from "../../actions/userAction";
import Button from "../ui/button/Button";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { configPaths } from '../../config';

export default function AllUserSubscriptions() {

  dayjs.extend(relativeTime);

  const perpage = configPaths.recordsPerPage;

  const navigate = useNavigate();
  
  const dispatch = useDispatch();

  const params = useParams();

  const [userSubscriptions, setUserSubscriptions] = useState([]);

  const [subscrptionPlans, setSubscrptionPlans] = useState([{
    id: 0,
    name: "All"
  }]);

  const [filtered, setFiltered] = useState(false);

  const [filterSelected, setFilterSelected] = useState({
    id: 0,
    name: "All"
  })

  const [filteredPlanName, setFilteredPlanName] = useState("");

  const [loadData, setLoadData] = useState(true);

  const getAllUserSubscriptionRes = useSelector(state => state.subscriptionReducer.getAllUserSubscription);

  const getAllUserSubscriptionFailed = useSelector(state => state.subscriptionReducer.getAllUserSubscriptionFailed);

  const getUserSubscriptionByPlanIdRes = useSelector(state => state.subscriptionReducer.getUserSubscriptionByPlanId);

  const getUserSubscriptionByPlanIdFailed = useSelector(state => state.subscriptionReducer.getUserSubscriptionByPlanIdFailed);

  const getAllSubscriptionsRes = useSelector(state => state.subscriptionReducer.getAllSubscriptionPlan);
  
  const getAllSubscriptionsFailed = useSelector(state => state.subscriptionReducer.getAllSubscriptionPlanFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

  const sendWhatsAppPaymentLinkRes = useSelector(state => state.paymentReducer.sendWhatsAppPaymentLink);

  const sendWhatsAppPaymentLinkFailed = useSelector(state => state.paymentReducer.sendWhatsAppPaymentLinkFailed);

  const [sendingWhatsAppFor, setSendingWhatsAppFor] = useState(null);

  const [showModal, setShowModal] = useState(false);
  
  const [planToDelete, setPlanToDelete] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);

  const badgeClasses = {
    in_progress: ["In Progress", "inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm bg-brand-50 text-brand-500 dark:bg-brand-500/15 dark:text-brand-400"],
    completed: ["Completed", "inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm bg-success-50 text-success-600 dark:bg-success-500/15 dark:text-success-500"],
    on_hold: ["On Hold", "inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm bg-error-50 text-error-600 dark:bg-error-500/15 dark:text-error-500"]
  }

  const paymentBadgeClasses = {
    pending: ["Pending", "inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm bg-warning-50 text-warning-600 dark:bg-warning-500/15 dark:text-warning-400"],
    partially_paid: ["Partially Paid", "inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm bg-brand-50 text-brand-500 dark:bg-brand-500/15 dark:text-brand-400"],
    paid: ["Paid", "inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm bg-success-50 text-success-600 dark:bg-success-500/15 dark:text-success-500"],
    failed: ["Failed", "inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm bg-error-50 text-error-600 dark:bg-error-500/15 dark:text-error-500"]
  }

  // A payment can still be collected while anything is outstanding.
  const isPayable = (payment) => {
    return payment != null && payment.id != null && payment.status !== "paid";
  }

  useEffect(() => {
    dispatch(checkAuth());
    dispatch(getAllSubscriptions());
    if(params.planId != undefined && !isNaN(params.planId)){
      dispatch(getUserSubscriptionByPlanId(params.planId));
    }
    else{
      dispatch(getAllUserSubscription(perpage,1));
    }
  }, []);

  useEffect(() => {
    console.log("Logged out error");
    if(checkAuthFailed.statusCode == 401){
      dispatch(emptyReduxUser());
      logout();
      navigate("/signin");
    }

  }, [checkAuthFailed]);

  useEffect(() => {
        
    if(typeof getAllSubscriptionsRes != "undefined" && getAllSubscriptionsRes.statusCode == 200){
      let data = [];

      let planlist = getAllSubscriptionsRes.data.plans;

      const planData = planlist.map((item) => {
          return {
            "id": item.id,
            "name": item.name,
          };
      });

      setSubscrptionPlans([
          ...[{id: 0,name: "All"}],
          ...planData
      ]);

      //setTotalRecords(getAllSubscriptionsRes.data.count);

    }

  }, [getAllSubscriptionsRes]);


  useEffect(() => {
      
    if(typeof getAllUserSubscriptionRes != "undefined" && getAllUserSubscriptionRes.statusCode == 200){

      let data = [];

      let userSubscriptionList = getAllUserSubscriptionRes.data.userSubscriptions;

      let userSubscriptionData = userSubscriptionList.map((item) => {

              return {
                id: item.id,
                subscriptionPlanId: item.subscriptionPlanId,
                userId: item.userId,
                startDate: item.startDate,
                endDate: item.endDate,
                status: item.status,
                createdAt: item.createdAt,
                updatedAt: item.updatedAt,
                subscriptionPlan: item.subscriptionPlan,
                user: item.user,
                payment: item?.payment
              };
      });
      
      setLoadData(false);

      setUserSubscriptions([
          ...userSubscriptionData
      ]);
      dispatch(resetGetAllUserSubscription());
      setFilteredPlanName("");
      setFiltered(false);

      setTotalRecords(getAllUserSubscriptionRes.data.count);
    }

  }, [getAllUserSubscriptionRes]);


  useEffect(() => {
      
    if(typeof getUserSubscriptionByPlanIdRes != "undefined" && getUserSubscriptionByPlanIdRes.statusCode == 200){

      let data = [];

      let userSubscriptionList = getUserSubscriptionByPlanIdRes.data.userSubscriptions;
      
      if ( userSubscriptionList.length > 0 ) {
        let userSubscriptionData = userSubscriptionList.map((item) => {

            return {
              id: item.id,
              subscriptionPlanId: item.subscriptionPlanId,
              userId: item.userId,
              startDate: item.startDate,
              endDate: item.endDate,
              status: item.status,
              createdAt: item.createdAt,
              updatedAt: item.updatedAt,
              subscriptionPlan: item.subscriptionPlan,
              user: item.user,
              payment: item?.payment
            };
        });
        
        setLoadData(false);

        setUserSubscriptions([
            ...userSubscriptionData
        ]);
        dispatch(resetGetUserSubscriptionByPlanId());
        setFiltered(true);
        setFilteredPlanName(userSubscriptionData[0].subscriptionPlan.name);

        setFilterSelected({id: userSubscriptionData[0].subscriptionPlan.id, name: userSubscriptionData[0].subscriptionPlan.name}); 
      } else {
        //toast.error("No Subscriper for this plan.", {autoClose:2000,onClose: () => {
          navigate("/subscription/all");
        //}});
      }
    }

  }, [getUserSubscriptionByPlanIdRes]);


  useEffect(() => {
    //console.log(getAllCustomerFailed);
    if(getAllUserSubscriptionFailed.statusCode == 401 || getAllUserSubscriptionFailed.statusCode == 500){

          //toast.error(getAllCustomerFailed.message, {autoClose:2000,onClose: () => {

                //logout();
                //navigate("/signin");
          //}});
          setLoadData(false);
    }
  }, [getAllUserSubscriptionFailed]);


  useEffect(() => {
    //console.log(getAllCustomerFailed);
    if(getUserSubscriptionByPlanIdFailed.statusCode == 401 || getUserSubscriptionByPlanIdFailed.statusCode == 500){

          //toast.error(getAllCustomerFailed.message, {autoClose:2000,onClose: () => {

                //logout();
                //navigate("/signin");
          //}});
          setLoadData(false);
    }
  }, [getUserSubscriptionByPlanIdFailed]);


  useEffect(() => {

    if(typeof sendWhatsAppPaymentLinkRes != "undefined" && sendWhatsAppPaymentLinkRes.statusCode == 200){

      setSendingWhatsAppFor(null);

      toast.success(sendWhatsAppPaymentLinkRes.message || "WhatsApp payment link sent successfully.", {
        position: "bottom-right",
        autoClose: 4000,
      });

      dispatch(resetSendWhatsAppPaymentLink());
    }

  }, [sendWhatsAppPaymentLinkRes]);


  useEffect(() => {

    if(sendWhatsAppPaymentLinkFailed && sendWhatsAppPaymentLinkFailed.statusCode){

      setSendingWhatsAppFor(null);

      if(sendWhatsAppPaymentLinkFailed.statusCode == 401){
        dispatch(emptyReduxUser());
        logout();
        navigate("/signin");
        return;
      }

      toast.error(sendWhatsAppPaymentLinkFailed.message || "Unable to send the WhatsApp payment link.", {
        position: "bottom-right",
        autoClose: 6000,
      });

      dispatch(resetSendWhatsAppPaymentLink());
    }

  }, [sendWhatsAppPaymentLinkFailed]);


  const handleSendWhatsAppLink = (userSubscriptionId) => {

    if(sendingWhatsAppFor !== null){
      return;
    }

    setSendingWhatsAppFor(userSubscriptionId);
    dispatch(sendWhatsAppPaymentLink(userSubscriptionId));
  };


  const handlePayNow = (item) => {

    const payuBase = configPaths.apiPath.replace("api/","")+'payu/';

    // Prefer the payment id: that route needs no lookup and is the one the
    // rest of the app already uses. Fall back to the subscription keyed route,
    // which raises this month's payment first, when the cron has not run yet.
    if(item?.payment?.id){
      window.open(payuBase+'createNewPaymentRequest/'+item.payment.id, "_blank");
      return;
    }

    if(item?.id == null || item?.id === ""){
      toast.error("Something went wrong..! Please try again later.", {position: "bottom-right", autoClose: 4000});
      return;
    }

    window.open(payuBase+'createPaymentRequestBySubscription/'+item.id, "_blank");
  };


  const handleUpiPay = (paymentId) => {

    if(paymentId == null || paymentId === ""){
      toast.error("No payment is due for this subscriber this month.", {position: "bottom-right", autoClose: 4000});
      return;
    }

    window.open(configPaths.apiPath+'payments/pay/redirect/'+paymentId, "_blank");
  };


  const handleFilterChange = (item) => {
    setFilterSelected(item);
    if(item.id === 0){
      dispatch(getAllUserSubscription());
    }
    else{
      dispatch(getUserSubscriptionByPlanId(item.id));
    }
  };

  const handleDeleteClick = (id) => {
    setPlanToDelete(id);
    setShowModal(true);  // Show the confirmation modal
  };

  const handleConfirmDelete = () => {
      dispatch(deleteUserSubscriptionById(planToDelete));
      setUserSubscriptions(userSubscriptions.filter(c => c.id !== planToDelete));  // Remove the deleted plan from the state
      setShowModal(false);  // Close the modal
      toast.success("Subscriper deleted successfully", {
        position: "bottom-right",
        autoClose: 4000,
      });
    };
    
    const handleCancelDelete = () => {
      setShowModal(false);  // Close the modal without doing anything
    };

    const handlePgNav = (typ) => {
      let pgNum = typ === "next" ? currentPage + 1 : currentPage - 1;

      if(pgNum < 1 || pgNum > Math.ceil(totalRecords / perpage)){
        return;
      }

      setCurrentPage(pgNum);
      setLoadData(true);
      dispatch(getAllUserSubscription(perpage, pgNum));
    };
  
    const handleChangePg = (pgNum) => {
      if(!isNaN(pgNum) && pgNum !== currentPage){
        setCurrentPage(pgNum);
        setLoadData(true);
        dispatch(getAllUserSubscription(perpage, pgNum));
      }
    };

  return (
    <>
      <PageMeta
        title="Subscribers | Chit Fund Management System"
        description="Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Subscribers" />
      <div className="space-y-6">
        <ComponentCard title="All subscribers list" btn="/subscription/user/add">
          
          <div className="grid grid-cols-1 gap-6 xl:grid-cols-1 filter-section">
            {/*<div className="text-right">
            <Listbox value={filterSelected} onChange={(e)=>handleFilterChange(e)}>
              <Label className="text-sm/6 font-medium text-gray-900">Filter By: </Label>
              <div className="relative inline-block">
                <ListboxButton className="grid max-w-4xl cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                  <span className="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                    <span className="block truncate">{filterSelected.name}</span>
                  </span>
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                  />
                </ListboxButton>

                <ListboxOptions
                  transition
                  className="absolute z-10 mt-1 max-h-56 max-4xl overflow-auto rounded-md bg-white py-1 text-base ring-1 shadow-lg ring-black/5 focus:outline-hidden data-leave:transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm"
                >
                  {subscrptionPlans.map((item) => (
                    <ListboxOption
                      key={item.id}
                      value={item}
                      className="group w-full relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-indigo-600 data-focus:text-white data-focus:outline-hidden flex justify-between"
                    >
                      <div className="flex items-center">
                        <span className="ml-3 block truncate font-normal group-data-selected:font-semibold  pr-4">{item.name}</span>
                      </div>
                      <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-not-data-selected:hidden group-data-focus:text-white">
                        {(
                          item.id == filterSelected.id
                          ?
                            <CheckLineIcon aria-hidden="true" className="size-5" />
                          :
                            null
                        )}
                      </span>
                    </ListboxOption>
                  ))}
                </ListboxOptions>
              </div>
            </Listbox>
            </div> */}

          </div>
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-white/[0.05] dark:bg-white/[0.03]">
            <div className="max-w-full overflow-x-auto">
              <div className="min-w-[1102px]">
                <Table>
                  {/* Table Header */}
                  <TableHeader className="border-b border-gray-100 dark:border-white/[0.05]">
                    <TableRow>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Customer name
                      </TableCell>
                      {(
                        filtered === false 
                        ?
                          <TableCell
                            isHeader
                            className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                          >
                            Plan name
                          </TableCell>
                        :
                          null
                      )}
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Schedule
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Duration
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Created At
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Status
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Payment
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHeader>

                  {/* Table Body */}
                  <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
                    {
                      userSubscriptions.length > 0 

                      ? 

                      userSubscriptions.map((item) => (

                        <TableRow key={item.id}>
                          <TableCell className="px-5 py-4 sm:px-6 text-start">
                            <div className="flex items-center gap-3">
                              <div>
                                <span className="block font-medium text-gray-800 text-theme-sm dark:text-white/90">
                                  {item.user.firstName + ' ' + item.user.lastName}
                                </span>
                              </div>
                            </div>
                          </TableCell>
                          {(

                            filtered === false 
                            
                            ?
                              <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                {item.subscriptionPlan.name}
                              </TableCell>
                            :
                              null
                          )}
                          <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {(
                              item.subscriptionPlan.scheduleType === "fixed"
                              ?
                              item.subscriptionPlan.tenure + ' ' + (item.subscriptionPlan.schedule == "monthly" ? "month(s)" : (item.subscriptionPlan.schedule == "weekly" ? "week(s)" : "year(s)"))
                              :
                              "-"
                            )}
                          </TableCell>
                          <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                            <div className="flex -space-x-2">
                            {dayjs(item.startDate).format('DD/MM/YYYY')} - {dayjs(item.endDate).format('DD/MM/YYYY')}
                            </div>
                          </TableCell>
                          <TableCell className="px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                            {dayjs(item.createdAt).format('DD/MM/YYYY') }
                          </TableCell>
                          <TableCell className="px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                            <span className={badgeClasses[item.status][1]}>{badgeClasses[item.status][0]}</span>
                          </TableCell>
                          <TableCell className="px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                            {(
                              item?.payment?.id
                              ?
                                <div className="flex flex-col gap-1 items-start">
                                  <span className={(paymentBadgeClasses[item.payment.status] || paymentBadgeClasses.pending)[1]}>
                                    {(paymentBadgeClasses[item.payment.status] || paymentBadgeClasses.pending)[0]}
                                  </span>
                                  {(
                                    isPayable(item.payment)
                                    ?
                                      <span className="text-xs">Due: {item.payment.balanceAmount}</span>
                                    :
                                      null
                                  )}
                                </div>
                              :
                                <span className="text-xs">No dues this month</span>
                            )}
                          </TableCell>
                          <TableCell className="text-center px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                            <div className="flex flex-cols-2 gap-6 xl:grid-cols-2 items-center">
                              <div className="space-y-6">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleSendWhatsAppLink(item.id)}
                                  title="Send payment link on WhatsApp"
                                  className={"text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-2.5 text-center text-sm inline-block" + (sendingWhatsAppFor === item.id ? " opacity-50 pointer-events-none" : "")}
                                >
                                  <WhatsAppIcon />
                                </Link>
                              </div>
                              {(
                                item?.payment?.id && !isPayable(item.payment)
                                ?
                                  <div className="space-y-6">
                                    <span className="text-xs text-success-600 dark:text-success-500 inline-block py-2.5">Paid</span>
                                  </div>
                                :
                                  <>
                                    <div className="space-y-6">
                                      <Button size="sm" variant="primary" onClick={() => handlePayNow(item)}>
                                        Pay Now
                                      </Button>
                                    </div>
                                    {(
                                      isPayable(item.payment)
                                      ?
                                        <div className="space-y-6">
                                          <Button size="sm" variant="outline" onClick={() => handleUpiPay(item.payment.id)}>
                                            UPI
                                          </Button>
                                        </div>
                                      :
                                        null
                                    )}
                                  </>
                              )}
                              <div className="space-y-6">
                                <Link
                                  to={"/subscription/user/edit/"+item.id}
                                  className="text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-2.5 text-center text-sm inline-block"
                                >
                                  <PencilIcon />
                                </Link>
                              </div>
                              <div className="space-y-6">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleDeleteClick(item.id)}
                                  className="text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-2.5 text-center text-sm inline-block"
                                >
                                  <TrashBinIcon />
                                </Link>
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      
                      ))

                    :
                      <TableRow>
                        <td colSpan={filtered === false ? 8 : 7} className="text-center py-6 text-gray-500">{(loadData === true ? "Loading..." : "No Records Found..!" )}</td>
                      </TableRow>
                    }

                  </TableBody>
                </Table>
              </div>
              {/* Pagination */}
              {
                userSubscriptions.length > 0 
                ?
                <Pagination
                  totalRecords={totalRecords}
                  perPage={perpage}
                  currentPage={currentPage}
                  handlePgNav={handlePgNav}
                  handleChangePg={handleChangePg}
                />
                :
                null
              }
            </div>
          </div>
        </ComponentCard>
      </div>
      {/* Custom Confirmation Modal using Tailwind CSS */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
            <h3 className="text-lg font-semibold text-gray-700">Confirm Deletion</h3>
            <p className="text-gray-600 mt-2">Are you sure you want to delete this user subscription?</p>
            <div className="mt-4 flex justify-end gap-4">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                onClick={handleCancelDelete}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                onClick={handleConfirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
}